import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const handleCtaClick = () => {
    trackAddToCart();
  };
  return <section id="oferta" className="py-20 px-6 md:px-12" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <FadeIn data-id="element-118">
          <div className="bg-warm-dark rounded-3xl p-8 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-119">
            {/* Decorative background elements */}
            <div className="absolute top-0 left-0 w-64 h-64 bg-rose-gold/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-120"></div>
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-copper/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" data-id="element-121"></div>

            <div className="relative z-10" data-id="element-122">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-123">
                Tu Inversión en Ti Misma
              </h2>
              <p className="text-xl text-cream/90 font-sans mb-2" data-id="element-124">
                Obtén hoy la Guía Maestra 'Renacer en 7 Días: El Código del
                Balance' por una inversión única.
              </p>
              <p className="text-rose-gold font-sans italic mb-10" data-id="element-125">
                Recupera tu bienestar por menos de lo que cuesta una salida a
                almorzar.
              </p>

              <div className="bg-white/5 border border-white/10 rounded-2xl p-8 max-w-md mx-auto mb-10 backdrop-blur-sm" data-id="element-126">
                <div className="inline-block bg-rose-gold text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4" data-id="element-127">
                  45% de descuento
                </div>
                <p className="text-cream/80 uppercase tracking-widest text-xs font-bold mb-3" data-id="element-128">
                  Precio Especial de Lanzamiento
                </p>
                <div className="flex justify-center items-center gap-4 mb-1" data-id="element-129">
                  <span className="text-2xl text-white/40 font-sans line-through" data-id="element-130">
                    $14.00
                  </span>
                </div>
                <div className="flex justify-center items-start" data-id="element-131">
                  <span className="text-2xl text-white font-bold mt-2 mr-1" data-id="element-132">
                    $
                  </span>
                  <span className="text-6xl font-serif font-bold text-white" data-id="element-133">
                    6.30
                  </span>
                  <span className="text-xl text-white/70 mt-8 ml-2" data-id="element-134">USD</span>
                </div>
                <p className="text-rose-gold/80 text-sm mt-2 font-sans" data-id="element-135">
                  ¡Ahorras $7.70!
                </p>
              </div>

              <a href="https://aeduclub.com/cart/47740141404378:1" target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="w-full max-w-md mx-auto bg-gradient-to-r from-rose-gold to-copper text-white font-bold font-sans text-lg py-5 px-8 rounded-full shadow-[0_0_20px_rgba(183,110,121,0.4)] hover:shadow-[0_0_30px_rgba(183,110,121,0.6)] hover:scale-[1.02] transition-all duration-300 flex items-center justify-center no-underline" data-id="element-136">
                ¡Sí, quiero descargar mi guía y recuperar mi balance ahora!
              </a>

              <div className="mt-6 flex items-center justify-center text-cream/60 text-sm font-sans" data-id="element-137">
                <ShieldCheck className="w-4 h-4 mr-2" data-id="element-138" />
                <span data-id="element-139">
                  Pago seguro y descarga instantánea. Tu privacidad es nuestra
                  prioridad.
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}